module.exports = __webpack_public_path__ + "img/iconfont.7f138aca.svg";